<div style="background-color: white;">
    <div fxLayout="row">
        <div fxFlex="88%" (click)="toggleSection()">
            <p style="font-size: 22px;padding: 10px;"><b>Test lists (10)</b></p>
        </div>
        <div fxFlex="10%" fxLayoutAlign="center center">
            <mat-icon (click)="toggleSection()" matSuffix class="toggleicon"
                *ngIf="!item_visible">keyboard_arrow_down</mat-icon>
            <mat-icon (click)="toggleSection()" class="toggleicon" *ngIf="item_visible">keyboard_arrow_up</mat-icon>
        </div>
    </div>

    <div *ngIf="item_visible">
        <div *ngFor="let product of partnerList; let l = index">

            <calsoft-partners-list [tenant]="secondaryTenantId" [data]="data" [product]="product">

            </calsoft-partners-list>


            <hr class="hrcss" />
        </div>
    </div>
</div>